// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"de4c1349","455":"ce7655c8"}[chunkId] + ".chunk.js";
};